import React from 'react';
import TablaVotosPartidos_CabeceraCurules from './TablaVotosPartidos_CabeceraCurules';
// import { useEleccion } from '../../contexts/eleccionContext';
import { useTranslate } from '../../contexts/languageContext';

const TablaVotosPartidos_Cabecera = ({mostrarCargos})=>{
    const t = useTranslate();
    // const elecOptions = useEleccion();
    // const {tableOptions:{mostrarCargos}} = elecOptions;
    const Span=mostrarCargos?1:2;

    return (
        <thead>
        <tr>
            <th colSpan={Span}>{t('partidosMayuscula')}</th>
            <th colSpan="2" className="votesCenter">{t('votos')}</th>
            {mostrarCargos && <TablaVotosPartidos_CabeceraCurules/>}
        </tr>
    </thead>
    )
};

export default TablaVotosPartidos_Cabecera;